export default __webpack_public_path__ + "static/media/spotify.0995a296.png";